import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { iMessage } from './imessage';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { SelectMediaComponent } from '../../../../select-media/select-media.component';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'iMessage';

@Component({
    selector: 'app-imessage',
    templateUrl: './imessage.component.html',
    styleUrls: ['./imessage.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, SelectMediaComponent, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, NextSelectorComponent]
})
export class ImessageComponent extends NodeBuilder implements OnInit {

  iMessageForm: UntypedFormGroup = undefined;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.iMessageForm = iMessage.toForm(stepData, this.canEdit);

    if (this.iMessageForm.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep();
      this.iMessageForm.get('next').setValue(this.newStep);
    }
  }

  get getStepData(): {} {
    const imessage = new iMessage();
    const rawValue = this.iMessageForm.getRawValue();
    imessage.setMenu(rawValue);
    const nodeData = imessage.nodeData;
    nodeData['next'] = rawValue.next;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.iMessageForm.markAllAsTouched();
    return this.iMessageForm.valid;
  }

  setImage(event, form) {
    form.get('imageReference').setValue(event);
  }
}
